// Register 'main-product-images' custom element if not already registered
class MainProductImages extends HTMLElement {
  constructor() {
    super();

    const images = this.querySelectorAll('[data-image-path]');

    this.imageObserver(images);

    // WORK IN PROGRESS -> MENU-1000
    //this.showOnlyVariantImages(images);
  }

  showOnlyVariantImages(images) {
    document.addEventListener('variant:changed', function (event) {
      let selected_variant = event.detail.variant;
      images.forEach((image) => {
        let imageURL = image.dataset.imagePath;
        let activeImage = selected_variant.featured_image.src.toLowerCase();
        if (!activeImage.includes(imageURL)) {
          if (imageURL.includes(selected_variant.sku)) {
            image.classList.remove('hidden');
          } else if (imageURL.startsWith('menu')) {
            image.classList.remove('hidden');
          } else {
            image.classList.add('hidden');
          }
        } else {
          image.classList.remove('hidden');
        }
      });
    });
  }

  // Set up IntersectionObservers for main product images
  imageObserver(images) {
    images.forEach((image) => {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            } else if (entry.isIntersecting) {
              this.scrollThumbnail(image); // Scroll the corresponding thumbnail
            }
          });
        },
        { threshold: 1 }
      );
      observer.observe(image); // Start observing the image
    });
  }

  // Scroll the corresponding thumbnail when the main product image is in view
  scrollThumbnail(image) {
    let thumbnailWrapper = document.querySelector('.product-thumbnails__container--wrapper');
    if (!thumbnailWrapper) {
      return;
    }
    const thumbnailImages = thumbnailWrapper.querySelectorAll('.product-thumbnails__item');
    let intersectingThumbnail;
    thumbnailImages.forEach((thumbnail) => {
      if (thumbnail.getAttribute('data-media-id') == image.getAttribute('data-media-id')) {
        intersectingThumbnail = thumbnail;
        return;
      }
    });

    if (intersectingThumbnail) {
      const thumbnailWrapperOffset = thumbnailWrapper.offsetTop;
      let style = window.getComputedStyle(intersectingThumbnail);
      let imageHeightInclMargin = intersectingThumbnail.offsetHeight + Number(style.getPropertyValue('margin-bottom').match(/\d+/)[0]);

      // Scroll the thumbnail wrapper smoothly to the intersecting thumbnail
      thumbnailWrapper.scrollTo({
        top: intersectingThumbnail.offsetTop - thumbnailWrapperOffset - imageHeightInclMargin,
        behavior: 'smooth'
      });

    }
  }
}
customElements.define('main-product-images', MainProductImages);
